module.exports = __webpack_public_path__ + "static/media/PictoEditarBlue.ff0c348e.svg";